export default {
  props: {
    addToGroup: {
      type: Object,
      required: false,
      default: null
    }
  }
}
